import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";

// Shared footer button rendered on both the Tests tab and the General
// Waiver Request tab. Fixed to the bottom of the screen (not just sticky
// within its own panel's scroll) so it's always visible regardless of
// scroll position — width matches the right panel's own current width
// (LoansPagev2's getRightPanelStyle) so it lines up with that column
// instead of stretching under the left panel too. Clicking it always opens
// the General Waiver Request form directly (never just the tab) — see
// onClick wiring at each call site in BridgeLoanResultTab.tsx /
// GeneralWaiverRequestTab.tsx.
export default function RequestGeneralWaiverFooter({
  onClick,
  width,
}: {
  onClick: () => void;
  width: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="general-waiver-sticky-footer"
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        width,
        zIndex: 1100,
        display: "flex",
        justifyContent: "flex-end",
        padding: "12px 16px",
        background: "#fff",
        borderTop: "1px solid #DBE2FF",
      }}
    >
      <Button
        variant="outlined"
        size="small"
        startIcon={<ChecklistOutlinedIcon fontSize="small" />}
        onClick={onClick}
        data-testid="request-general-waiver-button"
      >
        {t("requestGeneralWaiver")}
      </Button>
    </div>
  );
}
